import ButtonCard from "../UI/ButtonCard";
// @ts-expect-error pure js
import Tabs from "../UI/Tabs";
import Text from "../UI/Text";
import type { Courrier } from "../../models/courrier";
import styles from "./CardCourrier.module.css";

interface CardCourrierProps {
  courriers: Courrier[];
  onSelectCourrier: (staticId: string) => void;
  disabled?: boolean;
}

export default function CardCourrier({
  courriers,
  onSelectCourrier,
  disabled,
}: CardCourrierProps) {
  const { selectTab } = Tabs.useActiveTab();
  return (
    <div className={styles.grid}>
      {courriers.map((courrier) => (
        <ButtonCard
          key={courrier.id}
          onClick={() => {
            onSelectCourrier(courrier.static_id);
            selectTab("form");
          }}
          disabled={disabled}
        >
          <div className={styles.card}>
            <Text weight="bold">{courrier.nom}</Text>
            <Text>{courrier.text}</Text>
          </div>
        </ButtonCard>
      ))}
    </div>
  );
}
